import { AmplifyUser } from "@aws-amplify/ui";
import { AppThunk } from "../store";
import { selectUser } from "../selectors/userSelectors";
import { setUserCapabilities, setUserHasAccess, setUserId, setUserLoaded } from "../slices/userSlice";
import { getUserCapabilities, getUserHasAccess } from "../../services/userService";

export const initFetchData = (user: AmplifyUser): AppThunk => async (dispatch, getState) => {
    const { userLoaded } = selectUser(getState());

    if (user && !userLoaded) {
        dispatch(setUserId(user.username));

        const userHasAccess = getUserHasAccess(user);

        dispatch(setUserHasAccess(getUserHasAccess(user)));

        if (userHasAccess) {
            const userCapabilities = await getUserCapabilities(user.username);

            dispatch(setUserCapabilities(userCapabilities));
    
            // Load data here
    
            dispatch(setUserLoaded(true));
        }
    }
};